<template>
  <div class="ad-data-wrapper">
    <div class="ad-data-list-content">
      <div class="ad-data-list">
        <div class="ad-data-list-header">预算链接</div>
        <el-form :inline="true" class="pick-form-inline">
          <el-form-item class="pick-form-item" label="广告主">
            <el-select
              v-model="filter_channel_code"
              filterable
              clearable
              placeholder="请选择广告主"
              @change="handleFilterChange">
              <el-option
                v-for="item in channel_adv_code_list"
                :key="item.value"
                :label="item.label"
                :value="item.value"/>
            </el-select>
          </el-form-item>
          <el-form-item class="pick-form-item" label="搜索">
            <el-input
              class="adv-link-search"
              clearable
              placeholder="应用名称 / 链接标识"
              @input="handleFilterChange"
              prefix-icon="el-icon-search"
              v-model="search_keyword"/>
          </el-form-item>
          <el-form-item class="pick-form-item">
            <el-button v-permission="'adv_link:edit'" type="primary" @click="openAddDialog">添加</el-button>
          </el-form-item>
        </el-form>
        <el-table
          :data="tableData"
          row-key="id"
          stripe
          class="adv-media-table"
          style="width: 100%">
          <el-table-column type="expand">
            <template #default="scope">
              <div class="param-value-panel" v-if="scope.row.param_values && scope.row.param_values.length">
                <div
                  v-for="item in scope.row.param_values"
                  :key="item.param_name"
                  class="param-value-item">
                  <span class="param-value-name">{{ item.param_name }}</span>
                  <span class="param-value-text">{{ item.param_value || '—' }}</span>
                </div>
              </div>
              <div v-else class="param-value-empty">暂无解析参数，请配置点击链接并保存</div>
            </template>
          </el-table-column>
          <el-table-column prop="id" label="ID" width="100" align="center"/>
          <el-table-column prop="channel_name" label="广告主" width="120" show-overflow-tooltip/>
          <el-table-column prop="os_type" label="系统" width="100" align="center">
            <template #default="scope">
              {{ formatOsType(scope.row.os_type) }}
            </template>
          </el-table-column>
          <el-table-column prop="app_name" label="应用名称" width="200" show-overflow-tooltip/>
          <el-table-column prop="pkg_name" label="包名" width="200" show-overflow-tooltip/>
          <el-table-column
            prop="click_link"
            label="预算监测"
            min-width="200"
            show-overflow-tooltip/>
          <el-table-column prop="link_code" label="链接标识" width="200" show-overflow-tooltip/>
          <el-table-column prop="create_time" label="添加时间" width="200" show-overflow-tooltip/>
          <el-table-column label="操作" width="200" align="center" class-name="adv-media-op-col">
            <template #default="scope">
              <el-button v-permission="'adv_link:edit'" type="primary" size="mini" class="adv-link-operate-button" @click="openEditDialog(scope.row)">编辑</el-button>
              <el-popconfirm title="确定删除吗？" @confirm="handleRemove(scope.row)">
                <template #reference>
                  <el-button v-permission="'adv_link:edit'" type="danger" size="mini" class="adv-link-operate-button">删除</el-button>
                </template>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
        <div class="page-wrapper">
          <el-pagination
            class="page-pagination"
            background
            :hide-on-single-page="true"
            :current-page.sync="pageNum"
            :page-size="pageSize"
            :page-sizes="[10, 20, 50]"
            @size-change="handleSizeChange"
            @current-change="handlePageChange"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"/>
        </div>
      </div>
    </div>

    <el-dialog
      :title="isEdit ? '编辑预算链接' : '添加预算链接'"
      :visible.sync="dialogVisible"
      width="820px"
      :close-on-click-modal="false"
      @close="closeDialog">
      <el-form ref="formRef" class="budget-link-form" :model="form" :rules="rules" label-width="130px">
        <el-form-item label="广告主：" prop="channel_code">
          <el-select
            v-model="form.channel_code"
            filterable
            :disabled="isEdit"
            placeholder="请选择广告主"
            @change="handleChannelChange">
            <el-option
              v-for="item in addAdvChannelOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"/>
          </el-select>
        </el-form-item>
        <el-form-item label="系统类型：" prop="os_type">
          <el-radio-group v-model="form.os_type" :disabled="isEdit">
            <el-radio :label="1">安卓</el-radio>
            <el-radio :label="2">IOS</el-radio>
            <el-radio :label="0">不限</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="应用名称：" prop="app_name">
          <el-input v-model="form.app_name" maxlength="100" placeholder="请输入应用名称"/>
        </el-form-item>
        <el-form-item label="应用包名：" prop="pkg_name">
          <el-input v-model="form.pkg_name" maxlength="100" placeholder="选填"/>
        </el-form-item>
        <el-form-item :label="linkCodeLabel" prop="link_code">
          <el-input v-model="form.link_code" maxlength="500" :placeholder="linkCodePlaceholder" @input="syncMeituanMonitor"/>
        </el-form-item>
        <el-form-item v-if="form.channel_code === 'junbo'" label="adId：" prop="junbo_ad_id">
          <el-input v-model="form.junbo_ad_id" maxlength="100" placeholder="请输入预算 adId，点击上报写入骏伯 adId"/>
        </el-form-item>
        <el-form-item v-if="form.channel_code === 'youdao'" label="developer_id：" prop="youdao_developer_id">
          <el-input v-model="form.youdao_developer_id" maxlength="100" :placeholder="'默认 ' + youdaoDefaultDeveloperId"/>
        </el-form-item>
        <el-form-item label="下载链接：" prop="download_link">
          <el-input v-model="form.download_link" maxlength="2000" placeholder="选填"/>
        </el-form-item>
        <el-form-item
          v-if="form.channel_code === 'wanmob'"
          label="转化类型："
          prop="wanmob_event_type">
          <el-radio-group v-model="form.wanmob_event_type">
            <el-radio :label="1">激活</el-radio>
            <el-radio :label="2">注册</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          v-if="form.channel_code === 'bohai'"
          label="监测码："
          prop="bohai_pack_id">
          <el-input
            v-model="form.bohai_pack_id"
            maxlength="200"
            placeholder="请输入博海 packId"
            @input="syncBohaiClickLink"/>
        </el-form-item>
        <el-form-item label="点击链接：" prop="click_link">
          <el-input
            v-model="form.click_link"
            maxlength="4000"
            type="textarea"
            :rows="2"
            :readonly="form.channel_code === 'bohai' || form.channel_code === 'meituan'"
            :placeholder="clickLinkPlaceholder"
            @input="syncDerivedLinkCode"/>
        </el-form-item>
        <el-form-item label="曝光链接：" prop="show_link">
          <el-input
            v-model="form.show_link"
            maxlength="4000"
            type="textarea"
            :rows="2"
            :readonly="form.channel_code === 'meituan'"
            :placeholder="showLinkPlaceholder"
            @input="syncDerivedLinkCode"/>
        </el-form-item>
        <el-form-item label="备注：" prop="extra_info">
          <el-input v-model="form.extra_info" type="textarea" :rows="2" maxlength="2000" placeholder="选填"/>
        </el-form-item>
        <el-form-item v-if="linkParamHint.length" label="参数字典：">
          <div class="link-param-hint">
            <el-tag
              v-for="item in linkParamHint"
              :key="item.param_name"
              size="small"
              class="link-param-tag"
              :type="Number(item.param_required) === 0 ? 'danger' : 'info'">
              {{ formatLinkParamLabel(item) }}
            </el-tag>
          </div>
        </el-form-item>
        <el-form-item v-if="form.param_values.length" label="已解析：">
          <div class="parsed-param-list">
            <div v-for="item in form.param_values" :key="item.param_name" class="parsed-param-item">
              {{ item.param_name }} = {{ item.param_value }}
            </div>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取消</el-button>
        <el-button type="primary" :loading="submitLoading" @click="handleSubmit">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import {
    addAdvLink,
    fetchAdvLinkParam,
    getAdvLink,
    pageListAdvMedia,
    pageListAdLink,
    removeAdvLink,
    updateAdvLink
  } from '@/api/ad-data'

  export default {
    name: 'adv_budget_link_list',
    data() {
      return {
        pageNum: 1,
        pageSize: 10,
        total: 0,
        search_keyword: '',
        filter_channel_code: '',
        tableData: [],
        channel_adv_code_list: [],
        add_adv_channel_code_list: [],
        linkParamHint: [],
        dialogVisible: false,
        isEdit: false,
        submitLoading: false,
        form: {
          id: null,
          channel_code: '',
          os_type: 1,
          app_name: '',
          pkg_name: '',
          link_code: '',
          download_link: '',
          click_link: '',
          show_link: '',
          extra_info: '',
          param_values: [],
          wanmob_event_type: 1,
          bohai_pack_id: '',
          junbo_ad_id: '',
          youdao_developer_id: ''
        },
        youdaoDefaultDeveloperId: '381d8c4cc109487d',
        rules: {
          channel_code: [{required: true, message: '请选择广告主', trigger: 'change'}],
          os_type: [{required: true, message: '请选择系统类型', trigger: 'change'}],
          app_name: [{required: true, message: '请输入应用名称', trigger: 'blur'}],
          wanmob_event_type: [{
            validator: (rule, value, callback) => {
              if (this.form.channel_code === 'wanmob' && value !== 1 && value !== 2) {
                callback(new Error('请选择转化类型'))
                return
              }
              callback()
            },
            trigger: 'change'
          }],
          bohai_pack_id: [{
            validator: (rule, value, callback) => {
              if (this.form.channel_code === 'bohai' && !(value || '').trim()) {
                callback(new Error('请输入监测码 packId'))
                return
              }
              callback()
            },
            trigger: 'blur'
          }],
          link_code: [{
            validator: (rule, value, callback) => {
              if (this.form.channel_code === 'junbo' && !(value || '').trim()) {
                callback(new Error('请输入渠道ID'))
                return
              }
              if (this.form.channel_code === 'meituan' && !(value || '').trim()) {
                callback(new Error('请输入渠道号'))
                return
              }
              callback()
            },
            trigger: 'blur'
          }],
          junbo_ad_id: [{
            validator: (rule, value, callback) => {
              if (this.form.channel_code === 'junbo' && !(value || '').trim()) {
                callback(new Error('请输入adId'))
                return
              }
              callback()
            },
            trigger: 'blur'
          }],
          click_link: [{
            validator: (rule, value, callback) => {
              if (this.form.channel_code === 'ainian') {
                const raw = (value || '').trim()
                if (!raw) {
                  callback(new Error('请粘贴爱念监测链接'))
                  return
                }
                const oid = this.extractQueryParam(raw, 'oid')
                if (!oid || this.isLinkMacro(oid)) {
                  callback(new Error('链接中须包含 oid'))
                  return
                }
              }
              callback()
            },
            trigger: 'blur'
          }]
        }
      }
    },
    computed: {
      addAdvChannelOptions() {
        if (this.isEdit && this.form.channel_code) {
          const inWhitelist = this.add_adv_channel_code_list.some(
            item => item.value === this.form.channel_code
          )
          if (inWhitelist) {
            return this.add_adv_channel_code_list
          }
          const current = this.channel_adv_code_list.find(
            item => item.value === this.form.channel_code
          )
          if (current) {
            return [current, ...this.add_adv_channel_code_list]
          }
          return [{
            value: this.form.channel_code,
            label: this.form.channel_code
          }, ...this.add_adv_channel_code_list]
        }
        return this.add_adv_channel_code_list
      },
      linkCodeLabel() {
        if (this.form.channel_code === 'junbo') {
          return '渠道ID：'
        }
        if (this.form.channel_code === 'meituan') {
          return '渠道号：'
        }
        return '链接标识：'
      },
      linkCodePlaceholder() {
        if (this.form.channel_code === 'junbo') {
          return '请输入渠道ID，将作为链接标识'
        }
        if (this.form.channel_code === 'meituan') {
          return '请输入渠道号，将作为链接标识'
        }
        const placeholders = {
          inteyun: '不填则按 adId__channelId',
          zhijie: '不填则按 ckey',
          heimi: '不填则按 channel_pkg 或 did',
          ainian: '不填则按 channel_pkg 或 oid',
          juedui: '不填则按 channel_pkg 或 mainsn__channel_id',
          doujing: '不填则按 djMtId 或 djMtId__djPt',
          chengtou: '不填则按 offer_id__aff_id__ads_code',
          wanmob: '不填则按 product_id',
          bohai: '不填则按 packId',
          funmob: '不填则按 channelId__sign',
          ningzhi: '不填则按点击链接 yyq',
          soul: '不填则按点击链接路径末段数字',
          jinling: '不填则按点击链接路径末段数字',
          taqu: '不填则按 tq_gid_tq_pid',
          tianyuemeng: '不填则按 aid_did',
          zhongshi: '不填则按 aid_did',
          tubi: '不填则按点击链接 /ad/code/ 后的整段',
          vip: '不填则按曝光链接 monitor_spot_code',
          xiaohongshu: '不填则按点击链接 xhs_channel',
          xuanyi: '不填则按点击链接 pid',
          xuchao2: '不填则按点击链接 offer_id',
          xuchao3: '不填则按点击链接 ckey',
          yanxin: '不填则按点击链接 fid',
          keshuo2: '不填则按点击链接 channel_id',
          xuri: '不填则按点击链接 channel',
          youdao: '不填则按点击链接 aid',
          yoyo: '不填则按点击链接 dispatchCenterId',
          yunwap: '不填则按点击链接 channel',
          yunxunzhida: '不填则按点击链接 dispatch_item_id'
        }
        return placeholders[this.form.channel_code] || '选填'
      },
      clickLinkPlaceholder() {
        if (this.form.channel_code === 'wanmob') {
          return '粘贴 WanMob 官方监测链接即可，转化类型由上方选项决定，保存时自动拼接 event_type'
        }
        if (this.form.channel_code === 'bohai') {
          return '由上方 packId 自动生成（仅用于解析入库，实际上报为 POST JSON）'
        }
        if (this.form.channel_code === 'meituan') {
          return '由渠道号自动生成'
        }
        return '保存后将按预算媒体中配置的链接参数校验并解析'
      },
      showLinkPlaceholder() {
        if (this.form.channel_code === 'meituan') {
          return '由渠道号自动生成'
        }
        return '选填'
      }
    },
    mounted() {
      this.loadAdvertiserChannels()
      this.loadAddAdvertiserChannels()
      this.listBudgetLinks()
    },
    methods: {
      formatLinkParamLabel(item) {
        const name = item.param_name || ''
        const required = Number(item.param_required) === 0
        if (this.form.channel_code === 'wanmob' && name === 'event_type') {
          return 'event_type（保存时按转化类型自动拼接）'
        }
        if (this.form.channel_code === 'bohai' && name === 'packId') {
          return 'packId（由上方监测码自动拼接）'
        }
        return `${name}${required ? '（必填）' : ''}`
      },
      stripEventTypeFromClickLink(clickLink) {
        const raw = (clickLink || '').trim()
        if (!raw) {
          return {url: '', eventType: ''}
        }
        try {
          const parsed = new URL(raw)
          const eventType = parsed.searchParams.get('event_type') || ''
          parsed.searchParams.delete('event_type')
          return {url: parsed.toString(), eventType}
        } catch (e) {
          return {url: raw, eventType: ''}
        }
      },
      buildBohaiClickLink(packId) {
        const id = (packId || '').trim()
        if (!id) {
          return ''
        }
        return `https://ad.bohaiadx.com/cad/report?packId=${encodeURIComponent(id)}`
      },
      extractBohaiPackId(clickLink, paramValues) {
        const fromParam = ((paramValues || []).find(item => item.param_name === 'packId') || {}).param_value
        if (fromParam) {
          return String(fromParam).trim()
        }
        const raw = (clickLink || '').trim()
        if (!raw) {
          return ''
        }
        try {
          const parsed = new URL(raw)
          return (parsed.searchParams.get('packId')
            || parsed.searchParams.get('pack_id')
            || parsed.searchParams.get('rz_app_id')
            || '').trim()
        } catch (e) {
          return ''
        }
      },
      syncBohaiClickLink() {
        if (this.form.channel_code !== 'bohai') {
          return
        }
        this.form.click_link = this.buildBohaiClickLink(this.form.bohai_pack_id)
      },
      buildMeituanMonitorUrls(channelNo) {
        const source = encodeURIComponent((channelNo || '').trim())
        if (!source) {
          return {clickLink: '', showLink: ''}
        }
        return {
          clickLink: `https://apimobile.meituan.com/prom/v2/verify?source=${source}&app=group&coderesp=true&mt_channel=meituanunion`,
          showLink: `https://apimobile.meituan.com/prom/v2/action_monitor?source=${source}&app=group&monitor_type=impression&mt_channel=meituanunion`
        }
      },
      syncMeituanMonitor() {
        if (this.form.channel_code !== 'meituan') {
          return
        }
        const urls = this.buildMeituanMonitorUrls(this.form.link_code)
        this.form.click_link = urls.clickLink
        this.form.show_link = urls.showLink
      },
      extractQueryParam(rawUrl, name) {
        const raw = (rawUrl || '').trim()
        if (!raw) {
          return ''
        }
        try {
          return (new URL(raw).searchParams.get(name) || '').trim()
        } catch (e) {
          const matched = raw.match(new RegExp('[?&]' + name + '=([^&]*)'))
          return matched ? decodeURIComponent(matched[1] || '').trim() : ''
        }
      },
      syncNingzhiLinkCode() {
        if (this.form.channel_code !== 'ningzhi') {
          return
        }
        if ((this.form.link_code || '').trim()) {
          return
        }
        const yyq = this.extractQueryParam(this.form.click_link, 'yyq')
          || this.extractQueryParam(this.form.show_link, 'yyq')
        if (!yyq || (yyq.startsWith('__') && yyq.endsWith('__'))) {
          return
        }
        this.form.link_code = yyq
      },
      extractPathId(rawUrl) {
        const raw = (rawUrl || '').trim()
        if (!raw) {
          return ''
        }
        let path = ''
        try {
          path = new URL(raw).pathname || ''
        } catch (e) {
          path = raw.split('?')[0]
        }
        const segment = path.replace(/\/+$/, '').split('/').pop() || ''
        return /^\d+$/.test(segment) ? segment : ''
      },
      syncSoulLinkCode() {
        if (this.form.channel_code !== 'soul' && this.form.channel_code !== 'jinling') {
          return
        }
        if ((this.form.link_code || '').trim()) {
          return
        }
        const pathId = this.extractPathId(this.form.click_link)
        if (!pathId) {
          return
        }
        this.form.link_code = pathId
      },
      syncTaquLinkCode() {
        if (this.form.channel_code !== 'taqu') {
          return
        }
        if ((this.form.link_code || '').trim()) {
          return
        }
        const tqGid = this.extractQueryParam(this.form.click_link, 'tq_gid')
        const tqPid = this.extractQueryParam(this.form.click_link, 'tq_pid')
        if (!tqGid || !tqPid) {
          return
        }
        if ([tqGid, tqPid].some(item => item.startsWith('__') && item.endsWith('__'))) {
          return
        }
        this.form.link_code = tqGid + '_' + tqPid
      },
      syncTianyuemengLinkCode() {
        if (this.form.channel_code !== 'tianyuemeng') {
          return
        }
        if ((this.form.link_code || '').trim()) {
          return
        }
        const aid = this.extractQueryParam(this.form.click_link, 'aid')
        const did = this.extractQueryParam(this.form.click_link, 'did')
        if (!aid || !did) {
          return
        }
        if ([aid, did].some(item => item.startsWith('__') && item.endsWith('__'))) {
          return
        }
        this.form.link_code = aid + '_' + did
      },
      syncZhongshiLinkCode() {
        if (this.form.channel_code !== 'zhongshi') {
          return
        }
        if ((this.form.link_code || '').trim()) {
          return
        }
        const aid = this.extractQueryParam(this.form.click_link, 'aid')
        const did = this.extractQueryParam(this.form.click_link, 'did')
        if (!aid || !did) {
          return
        }
        if ([aid, did].some(item => this.isLinkMacro(item))) {
          return
        }
        this.form.link_code = aid + '_' + did
      },
      syncTubiLinkCode() {
        if (this.form.channel_code !== 'tubi') {
          return
        }
        if ((this.form.link_code || '').trim()) {
          return
        }
        const link = this.form.click_link || ''
        const matched = link.match(/\/ad\/code\/([^/?#]+)/i)
        if (!matched) {
          return
        }
        const segment = decodeURIComponent(matched[1]).replace(/\/+$/, '')
        if (!segment || (segment.startsWith('__') && segment.endsWith('__'))) {
          return
        }
        this.form.link_code = segment
      },
      syncVipLinkCode() {
        if (this.form.channel_code !== 'vip') {
          return
        }
        if ((this.form.link_code || '').trim()) {
          return
        }
        const spot = this.extractQueryParam(this.form.show_link, 'monitor_spot_code')
        if (!spot || (spot.startsWith('__') && spot.endsWith('__'))) {
          return
        }
        this.form.link_code = spot
      },
      syncXiaohongshuLinkCode() {
        if (this.form.channel_code !== 'xiaohongshu') {
          return
        }
        if ((this.form.link_code || '').trim()) {
          return
        }
        const xhsChannel = this.extractQueryParam(this.form.click_link, 'xhs_channel')
        if (!xhsChannel || (xhsChannel.startsWith('__') && xhsChannel.endsWith('__'))) {
          return
        }
        this.form.link_code = xhsChannel
      },
      syncXuanyiLinkCode() {
        if (this.form.channel_code !== 'xuanyi') {
          return
        }
        if ((this.form.link_code || '').trim()) {
          return
        }
        const pid = this.extractQueryParam(this.form.click_link, 'pid')
        if (!pid || (pid.startsWith('__') && pid.endsWith('__'))) {
          return
        }
        this.form.link_code = pid
      },
      isLinkMacro(value) {
        const text = (value || '').trim()
        if (!text) {
          return true
        }
        if (text.startsWith('__') && text.endsWith('__')) {
          return true
        }
        return text.startsWith('{') && text.endsWith('}')
      },
      syncXuchao2LinkCode() {
        if (this.form.channel_code !== 'xuchao2') {
          return
        }
        if ((this.form.link_code || '').trim()) {
          return
        }
        const offerId = this.extractQueryParam(this.form.click_link, 'offer_id')
        if (this.isLinkMacro(offerId)) {
          return
        }
        this.form.link_code = offerId
      },
      syncXuchao3LinkCode() {
        if (this.form.channel_code !== 'xuchao3') {
          return
        }
        if ((this.form.link_code || '').trim()) {
          return
        }
        const ckey = this.extractQueryParam(this.form.click_link, 'ckey')
        if (this.isLinkMacro(ckey)) {
          return
        }
        this.form.link_code = ckey
      },
      syncYanxinLinkCode() {
        if (this.form.channel_code !== 'yanxin') {
          return
        }
        if ((this.form.link_code || '').trim()) {
          return
        }
        const fid = this.extractQueryParam(this.form.click_link, 'fid')
        if (this.isLinkMacro(fid)) {
          return
        }
        this.form.link_code = fid
      },
      syncKeshuo2LinkCode() {
        if (this.form.channel_code !== 'keshuo2') {
          return
        }
        if ((this.form.link_code || '').trim()) {
          return
        }
        const channelId = this.extractQueryParam(this.form.click_link, 'channel_id')
        if (this.isLinkMacro(channelId)) {
          return
        }
        this.form.link_code = channelId
      },
      syncXuriLinkCode() {
        if (this.form.channel_code !== 'xuri') {
          return
        }
        if ((this.form.link_code || '').trim()) {
          return
        }
        const channel = this.extractQueryParam(this.form.click_link, 'channel')
        if (this.isLinkMacro(channel)) {
          return
        }
        this.form.link_code = channel
      },
      syncYoudaoLinkCode() {
        if (this.form.channel_code !== 'youdao') {
          return
        }
        const developerId = this.extractQueryParam(this.form.click_link, 'developer_id')
        if (developerId && !this.isLinkMacro(developerId)) {
          this.form.youdao_developer_id = developerId
        } else if (!(this.form.youdao_developer_id || '').trim()) {
          this.form.youdao_developer_id = this.youdaoDefaultDeveloperId
        }
        const redirect = this.extractQueryParam(this.form.click_link, 'redirect')
        const aid = this.extractQueryParam(this.form.click_link, 'aid')
        const values = []
        if (aid && !this.isLinkMacro(aid)) {
          values.push({param_name: 'aid', param_value: aid})
        }
        values.push({
          param_name: 'developer_id',
          param_value: (this.form.youdao_developer_id || '').trim() || this.youdaoDefaultDeveloperId
        })
        if (redirect && !this.isLinkMacro(redirect)) {
          values.push({param_name: 'redirect', param_value: redirect})
        }
        if (values.length) {
          this.form.param_values = values
        }
        if ((this.form.link_code || '').trim()) {
          return
        }
        if (this.isLinkMacro(aid)) {
          return
        }
        this.form.link_code = aid
      },
      syncYoyoLinkCode() {
        if (this.form.channel_code !== 'yoyo') {
          return
        }
        if ((this.form.link_code || '').trim()) {
          return
        }
        const dispatchCenterId = this.extractQueryParam(this.form.click_link, 'dispatchCenterId')
        if (this.isLinkMacro(dispatchCenterId)) {
          return
        }
        this.form.link_code = dispatchCenterId
      },
      syncYunwapLinkCode() {
        if (this.form.channel_code !== 'yunwap') {
          return
        }
        if ((this.form.link_code || '').trim()) {
          return
        }
        const channel = this.extractQueryParam(this.form.click_link, 'channel')
        if (this.isLinkMacro(channel)) {
          return
        }
        this.form.link_code = channel
      },
      syncYunxunzhidaLinkCode() {
        if (this.form.channel_code !== 'yunxunzhida') {
          return
        }
        if ((this.form.link_code || '').trim()) {
          return
        }
        const dispatchItemId = this.extractQueryParam(this.form.click_link, 'dispatch_item_id')
        if (this.isLinkMacro(dispatchItemId)) {
          return
        }
        this.form.link_code = dispatchItemId
      },
      syncShirui2LinkCode() {
        if (this.form.channel_code !== 'shirui2') {
          return
        }
        if ((this.form.link_code || '').trim()) {
          return
        }
        const adid = this.extractQueryParam(this.form.click_link, 'adid')
        const channelid = this.extractQueryParam(this.form.click_link, 'channelid')
        if (this.isLinkMacro(adid) || this.isLinkMacro(channelid)) {
          return
        }
        this.form.link_code = adid + '_' + channelid
      },
      syncAinianLinkCode() {
        if (this.form.channel_code !== 'ainian') {
          return
        }
        if ((this.form.link_code || '').trim()) {
          return
        }
        const channelPkg = this.extractQueryParam(this.form.click_link, 'channel_pkg')
        const oid = this.extractQueryParam(this.form.click_link, 'oid')
        if (channelPkg && !this.isLinkMacro(channelPkg)) {
          this.form.link_code = channelPkg
          return
        }
        if (oid && !this.isLinkMacro(oid)) {
          this.form.link_code = oid
        }
      },
      syncDerivedLinkCode() {
        this.syncShirui2LinkCode()
        this.syncAinianLinkCode()
        this.syncNingzhiLinkCode()
        this.syncSoulLinkCode()
        this.syncTaquLinkCode()
        this.syncTianyuemengLinkCode()
        this.syncZhongshiLinkCode()
        this.syncTubiLinkCode()
        this.syncVipLinkCode()
        this.syncXiaohongshuLinkCode()
        this.syncXuanyiLinkCode()
        this.syncXuchao2LinkCode()
        this.syncXuchao3LinkCode()
        this.syncYanxinLinkCode()
        this.syncKeshuo2LinkCode()
        this.syncXuriLinkCode()
        this.syncYoudaoLinkCode()
        this.syncYoyoLinkCode()
        this.syncYunwapLinkCode()
        this.syncYunxunzhidaLinkCode()
      },
      resolveWanmobFormFields(data) {
        let clickLink = data.click_link || ''
        let wanmobEventType = 1
        if (data.channel_code !== 'wanmob') {
          return {clickLink, wanmobEventType}
        }
        const stripped = this.stripEventTypeFromClickLink(clickLink)
        clickLink = stripped.url
        const paramEventType = ((data.param_values || []).find(item => item.param_name === 'event_type') || {}).param_value
        const eventType = paramEventType || stripped.eventType
        wanmobEventType = Number(eventType) === 2 ? 2 : 1
        return {clickLink, wanmobEventType}
      },
      resolveBohaiFormFields(data) {
        const packId = this.extractBohaiPackId(data.click_link, data.param_values)
        return {
          bohaiPackId: packId,
          clickLink: packId ? this.buildBohaiClickLink(packId) : (data.click_link || '')
        }
      },
      formatOsType(value) {
        if (Number(value) === 0) {
          return '不限'
        }
        if (Number(value) === 1) {
          return '安卓'
        }
        if (Number(value) === 2) {
          return 'IOS'
        }
        return value
      },
      handleFilterChange() {
        this.pageNum = 1
        this.listBudgetLinks()
      },
      handlePageChange(page) {
        this.pageNum = page
        this.listBudgetLinks()
      },
      handleSizeChange(size) {
        this.pageSize = size
        this.pageNum = 1
        this.listBudgetLinks()
      },
      loadAdvertiserChannels() {
        pageListAdvMedia({
          page_num: 1,
          page_size: 500,
          query_param: {up_down_type: 1}
        }).then(res => {
          const list = (res.data.data && res.data.data.list) || []
          this.channel_adv_code_list = list.map(item => ({
            value: item.channel_code,
            label: item.channel_name
          }))
        })
      },
      loadAddAdvertiserChannels() {
        pageListAdvMedia({
          page_num: 1,
          page_size: 500,
          query_param: {up_down_type: 1, budget_link_whitelist: 1}
        }).then(res => {
          const list = (res.data.data && res.data.data.list) || []
          this.add_adv_channel_code_list = list.map(item => ({
            value: item.channel_code,
            label: item.channel_name
          }))
        })
      },
      listBudgetLinks() {
        pageListAdLink({
          page_num: this.pageNum,
          page_size: this.pageSize,
          query_param: {
            channel_code: this.filter_channel_code,
            keyword: this.search_keyword
          }
        }).then(res => {
          const data = res.data.data
          if (data != null) {
            this.tableData = data.list || []
            this.total = data.total || 0
          }
        })
      },
      resetForm() {
        this.form = {
          id: null,
          channel_code: '',
          os_type: 1,
          app_name: '',
          pkg_name: '',
          link_code: '',
          download_link: '',
          click_link: '',
          show_link: '',
          extra_info: '',
          param_values: [],
          wanmob_event_type: 1,
          bohai_pack_id: '',
          junbo_ad_id: '',
          youdao_developer_id: ''
        }
        this.linkParamHint = []
      },
      loadLinkParamHint(channelCode) {
        if (!channelCode) {
          this.linkParamHint = []
          return
        }
        fetchAdvLinkParam(channelCode).then(res => {
          const data = res.data.data
          this.linkParamHint = (data && data.params) ? data.params.filter(item => Number(item.is_active) === 0) : []
        }).catch(() => {
          this.linkParamHint = []
        })
      },
      handleChannelChange(channelCode) {
        this.loadLinkParamHint(channelCode)
        if (channelCode === 'wanmob' && this.form.wanmob_event_type !== 1 && this.form.wanmob_event_type !== 2) {
          this.form.wanmob_event_type = 1
        }
        if (channelCode === 'bohai') {
          if (!this.form.bohai_pack_id) {
            this.form.bohai_pack_id = this.extractBohaiPackId(this.form.click_link, this.form.param_values)
          }
          this.syncBohaiClickLink()
        } else {
          this.form.bohai_pack_id = ''
        }
        if (channelCode !== 'junbo') {
          this.form.junbo_ad_id = ''
        }
        if (channelCode === 'youdao') {
          if (!(this.form.youdao_developer_id || '').trim()) {
            this.form.youdao_developer_id = this.youdaoDefaultDeveloperId
          }
        } else {
          this.form.youdao_developer_id = ''
        }
        if (channelCode === 'meituan') {
          this.syncMeituanMonitor()
        }
        this.syncDerivedLinkCode()
      },
      openAddDialog() {
        this.isEdit = false
        this.resetForm()
        this.dialogVisible = true
        this.$nextTick(() => {
          if (this.$refs.formRef) {
            this.$refs.formRef.clearValidate()
          }
        })
      },
      openEditDialog(row) {
        this.isEdit = true
        getAdvLink(row.id).then(res => {
          const data = res.data.data || {}
          const wanmobFields = this.resolveWanmobFormFields(data)
          const bohaiFields = this.resolveBohaiFormFields(data)
          const isBohai = data.channel_code === 'bohai'
          this.form = {
            id: data.id,
            channel_code: data.channel_code,
            os_type: Number(data.os_type),
            app_name: data.app_name || '',
            pkg_name: data.pkg_name || '',
            link_code: data.link_code || '',
            download_link: data.download_link || '',
            click_link: isBohai ? bohaiFields.clickLink : wanmobFields.clickLink,
            show_link: data.show_link || '',
            extra_info: data.extra_info || '',
            param_values: data.param_values || [],
            wanmob_event_type: wanmobFields.wanmobEventType,
            bohai_pack_id: isBohai ? bohaiFields.bohaiPackId : '',
            junbo_ad_id: data.channel_code === 'junbo'
              ? (((data.param_values || []).find(item => item.param_name === 'adId') || {}).param_value || '')
              : '',
            youdao_developer_id: data.channel_code === 'youdao'
              ? ((((data.param_values || []).find(item => item.param_name === 'developer_id') || {}).param_value
                || ((data.param_values || []).find(item => item.param_name === 'did') || {}).param_value
                || this.youdaoDefaultDeveloperId))
              : ''
          }
          this.loadLinkParamHint(data.channel_code)
          if (data.channel_code === 'meituan') {
            this.syncMeituanMonitor()
          }
          this.syncDerivedLinkCode()
          this.dialogVisible = true
          this.$nextTick(() => {
            if (this.$refs.formRef) {
              this.$refs.formRef.clearValidate()
            }
          })
        })
      },
      closeDialog() {
        this.dialogVisible = false
        this.isEdit = false
        this.submitLoading = false
        this.resetForm()
        if (this.$refs.formRef) {
          this.$refs.formRef.resetFields()
        }
      },
      buildSubmitPayload() {
        if (this.form.channel_code === 'bohai') {
          this.syncBohaiClickLink()
        }
        if (this.form.channel_code === 'meituan') {
          this.syncMeituanMonitor()
        }
        this.syncDerivedLinkCode()
        const payload = {
          id: this.form.id,
          channel_code: this.form.channel_code,
          os_type: this.form.os_type,
          app_name: this.form.app_name.trim(),
          pkg_name: this.form.pkg_name.trim(),
          link_code: this.form.link_code.trim(),
          download_link: this.form.download_link.trim(),
          click_link: this.form.click_link.trim(),
          show_link: this.form.show_link.trim(),
          extra_info: this.form.extra_info.trim()
        }
        if (this.form.channel_code === 'wanmob') {
          payload.event_type = String(this.form.wanmob_event_type)
        }
        if (this.form.channel_code === 'junbo') {
          payload.ad_id = (this.form.junbo_ad_id || '').trim()
        }
        if (this.form.channel_code === 'youdao') {
          payload.developer_id = (this.form.youdao_developer_id || '').trim() || this.youdaoDefaultDeveloperId
        }
        return payload
      },
      handleSubmit() {
        this.$refs.formRef.validate(valid => {
          if (!valid) {
            return false
          }
          this.submitLoading = true
          const payload = this.buildSubmitPayload()
          const request = this.isEdit ? updateAdvLink(payload) : addAdvLink(payload)
          request.then(() => {
            this.$message.success('保存成功')
            this.closeDialog()
            if (!this.isEdit) {
              this.pageNum = 1
            }
            this.listBudgetLinks()
          }).finally(() => {
            this.submitLoading = false
          })
        })
      },
      handleRemove(row) {
        removeAdvLink(row.id).then(() => {
          this.$message.success('删除成功')
          this.pageNum = 1
          this.listBudgetLinks()
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .ad-data-list-content {
    display: flex;
  }

  .ad-data-list {
    width: 100%;
  }

  .ad-data-list-header {
    font-weight: 600;
    font-size: 24px;
    line-height: 40px;
    color: #212121;
    word-break: break-word;
    padding-bottom: 20px;
  }

  .page-wrapper {
    margin-top: 20px;
    width: 100%;
    display: flex;
    justify-content: center;
  }

  .pick-form-inline {
    padding: 0 10px;
  }

  .budget-link-form {
    ::v-deep .el-form-item__label {
      white-space: nowrap;
    }
  }

  .pick-form-item {
    padding-right: 30px;
  }

  .adv-link-search {
    width: 280px;
  }

  .adv-link-operate-button {
    margin-right: 6px;
  }

  .adv-media-table {
    width: 100%;

    ::v-deep .el-table__header-wrapper table,
    ::v-deep .el-table__body-wrapper table {
      table-layout: fixed;
      width: 100%;
    }

    ::v-deep .adv-media-op-col .cell {
      white-space: normal;
      overflow: visible;
    }
  }

  .param-value-panel {
    padding: 8px 16px;
  }

  .param-value-item {
    line-height: 28px;
  }

  .param-value-name {
    display: inline-block;
    width: 120px;
    color: #606266;
  }

  .param-value-empty {
    padding: 8px 16px;
    color: #909399;
  }

  .link-param-hint {
    line-height: 28px;
  }

  .link-param-tag {
    margin-right: 8px;
    margin-bottom: 4px;
  }

  .parsed-param-list {
    line-height: 24px;
    color: #606266;
  }

</style>
